import {
	lazy,
} from 'react'

export const ProfilePageAsync = lazy(async() => {
	return import('./profile.page')
})
